import { Fragment } from 'react'
import { useSearchParams } from 'react-router'

import { SUBMENU_PARAM_KEY } from '../../../constants/route'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../Table'
import { EMAIL_TABLE_ROW_ACTIONS_CONFIG } from '../Email.constants'
import { EmailTableRowActions } from '../EmailTableRowActions'

import {
  checkIsRowFocused,
  getCellClassName,
  isImportantButtonDisabled,
  renderCell,
} from './EmailTableRow.utils'

import * as styles from './EmailTableRow.module.css'

function EmailTableRow({
  Actions = EmailTableRowActions,
  ImportantButton,
  actionLeft,
  actionsColumnWidth,
  activeItem,
  attachedFilesProps,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  getArrowNavigationItemProps,
  hideCheckbox,
  index,
  isResizing,
  isSelected,
  isShort,
  item,
  resizingColumn,
  scrollRef,
  showCellBorder,
  singleEmailAccount,
  onSetImportant,
  ...restProps
}) {
  const { starred, uuid: id } = item

  const [searchParams] = useSearchParams()

  const {
    handleCallAction,
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps }, EMAIL_TABLE_ROW_ACTIONS_CONFIG)

  const sub = searchParams.get(SUBMENU_PARAM_KEY)

  const className = useTableRowModClassName({
    className: styles.EmailTableRow,
    isActive: focusedRow === id || activeItem === id,
    isSelected,
  })

  const qaProps = getTableRowQaProps()

  function handleSetImportant(important) {
    onSetImportant?.(id, important)
  }

  return (
    <div
      {...qaProps}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
      key={id}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          ImportantButton={ImportantButton}
          disabledCheckbox={hideCheckbox}
          disabledImportant={isImportantButtonDisabled(sub, item)}
          important={starred}
          selected={isSelected}
          width={actionsColumnWidth}
          onSelect={handleSelect}
          onSetImportant={handleSetImportant}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            attachedFilesProps,
            className: getCellClassName(column.name),
            isActive: resizingColumn === column.name && isResizing,
            isResizing,
            isShort,
            item,
            name: column.name,
            scrollRef,
            showCellBorder,
            singleEmailAccount,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item)?.length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          checkIsRowFocused={checkIsRowFocused}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default EmailTableRow
